module.exports = __webpack_public_path__ + "static/media/tex-trends-selection-fw2425.05182db7.png";